/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react'
import PropTypes from 'prop-types'
import { _ } from '@iskytrip/sdk'
import CSS from './index.module.scss'
import BaseComponent from '@base/BaseComponent'
// import { isEmpty } from 'lodash'
import { IconCodeEmum, Iconfont } from '@src/components'
import { Modal } from 'antd-mobile'
import IconRight from '@assets/icon/ic_right.png'
import './main.scss'

class ServiceModal extends BaseComponent {
	static propTypes = {
		isShow: PropTypes.bool,
		title: PropTypes.string,
		serviceTagList: PropTypes.array,
		close: PropTypes.func,
	}

	static defaultProps = {
		isShow: false,
		title: '',
		serviceTagList: [],
		close: () => {},
	}

	/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ 生命周期 */
	constructor(props) {
		super(props)
		this.state = {
			activeIndex: -1,
		}
	}

	render() {
		let { isShow, serviceTagList, close, title } = this.props
		// console.log('serviceTagList === ', serviceTagList)

		return (
			<Modal
				popup
				visible={isShow}
				className={CSS.modalService}
				animationType='slide-up'
				onClose={close.bind(this)}
			>
				<div className={CSS.scrollViewComp}>
					<div className={CSS.modalTitle}>
						<label>{title}</label>
						<Iconfont
							font={IconCodeEmum.CLOSE}
							style={{ fontSize: '.32rem', color: '#D8D8D8' }}
							onPress={close.bind(this)}
						/>
					</div>
					<div className='package-drop_service'>
						{serviceTagList &&
							serviceTagList.map((item, index) => (
								<div className='service-protect_item' key={index}>
									<div className='service-protect_title'>
										<img src={item.icon || IconRight} alt='icon' />
										<label>{item.tagKey}</label>
									</div>
									<label className='service-protect_text'>{item.tagValue}</label>
								</div>
							))}
					</div>
				</div>
			</Modal>
		)
	}
}

export default ServiceModal
